import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ManageSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [newSubjectName, setNewSubjectName] = useState('');
  const [selectedProgram, setSelectedProgram] = useState('');
  const [selectedSemester, setSelectedSemester] = useState('');
  const [programs, setPrograms] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);

  // Fetch programs and semesters from the backend
  useEffect(() => {
    const fetchProgramsAndSemesters = async () => {
      try {
        const [programsRes, semestersRes] = await Promise.all([
          axios.get('http://localhost:8081/api/admin/programs'), // Adjust API endpoint accordingly
          axios.get('http://localhost:8081/api/admin/semesters'), // Adjust API endpoint accordingly
        ]);
        setPrograms(programsRes.data);
        console.log(semestersRes.data);

        setSemesters(semestersRes.data);
      } catch (error) {
        console.error("Error fetching programs and semesters:", error);
      }
    };

    fetchProgramsAndSemesters();
  }, []);

  // Fetch all subjects from the backend
  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get('http://localhost:8081/api/admin/subjects');
        setSubjects(response.data);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    fetchSubjects();
  }, []);

  const handleAddOrUpdate = async () => {
    if (!newSubjectName || !selectedProgram || !selectedSemester) return;

    const programObj = programs.find(p => p.name === selectedProgram);
    const semesterObj = semesters.find(s => s.name === selectedSemester && s.program === selectedProgram);

    const subjectData = {
      name: newSubjectName,
      code: '', // Optional: if you want to use a code later
      program: selectedProgram,
      semester: selectedSemester,
      program_id: programObj?.id,
      semester_id: semesterObj?.semester_id,
    };

    if (!subjectData.program_id || !subjectData.semester_id) {
      console.error("Program ID or Semester ID not found");
      return;
    }

    if (editingIndex !== null) {
      try {
        const subjectId = subjects[editingIndex].id;
        await axios.put(`http://localhost:8081/api/admin/subjects/${subjectId}`, subjectData);
        const updatedSubjects = [...subjects];
        updatedSubjects[editingIndex] = { ...subjectData, id: subjectId };
        setSubjects(updatedSubjects);
        setEditingIndex(null);
      } catch (error) {
        console.error("Error updating subject:", error);
      }
    } else {
      try {
        const res = await axios.post('http://localhost:8081/api/admin/subjects', subjectData);
        const newId = res.data.id;
        setSubjects([...subjects, { ...subjectData, id: newId }]);
      } catch (error) {
        console.error("Error adding subject:", error);
      }
    }

    setNewSubjectName('');
    setSelectedProgram('');
    setSelectedSemester('');
  };


  const handleEdit = (index) => {
    const subject = subjects[index];
    setNewSubjectName(subject.name);
    setSelectedProgram(subject.program);
    setSelectedSemester(subject.semester);
    setEditingIndex(index);
  };

  const handleDelete = async (index) => {
    const subjectId = subjects[index].id;
    try {
      await axios.delete(`http://localhost:8081/api/admin/subjects/${subjectId}`);
      setSubjects(subjects.filter((_, i) => i !== index));
      if (editingIndex === index) setEditingIndex(null);
    } catch (error) {
      console.error("Error deleting subject:", error);
    }
  };

  return (
    <div className="manage-subjects">
      <div className="header">
        <h2>Manage Subjects</h2>
        <button onClick={handleAddOrUpdate} className="add-btn">
          {editingIndex !== null ? 'Save Changes' : 'Add Subject'}
        </button>
      </div>

      <div className="subject-form">
        <input
          type="text"
          placeholder="Subject Name"
          value={newSubjectName}
          onChange={(e) => setNewSubjectName(e.target.value)}
        />
        <select
          value={selectedProgram}
          onChange={(e) => setSelectedProgram(e.target.value)}
        >
          <option value="">Select Program</option>
          {programs.map((program) => (
            <option key={program.id} value={program.name}>{program.name}</option>
          ))}
        </select>

        <select
          value={selectedSemester}
          onChange={(e) => setSelectedSemester(e.target.value)}
        >
          <option value="">Select Semester</option>
          {semesters
            .filter((semester) => semester.program === selectedProgram)
            .map((semester) => (
              <option key={semester.semester_id} value={semester.name}>{semester.name}</option>
            ))}
        </select>

      </div>

      <div className="subjects-list">
        <table className="subjects-table">
          <thead>
            <tr>
              <th>Subject</th>
              <th>Program</th>
              <th>Semester</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {subjects.map((subject, index) => (
              <tr key={subject.id || index}>
                <td>{subject.name}</td>
                <td>{subject.program}</td>
                <td>{subject.semester}</td>
                <td>
                  <button onClick={() => handleEdit(index)} className="edit">Edit</button>
                  <button onClick={() => handleDelete(index)} className="delete">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageSubjects;
